import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export type SortDir = "asc" | "desc";

export interface SortHeaderProps<K extends string> {
  label: string;
  sortKey: K;
  activeSort: K;
  activeDir: SortDir;
  onSort: (key: K) => void;
}

export function SortHeader<K extends string>({
  label,
  sortKey,
  activeSort,
  activeDir,
  onSort,
}: SortHeaderProps<K>): React.JSX.Element {
  const isActive = activeSort === sortKey;
  const Icon = !isActive
    ? ArrowUpDown
    : activeDir === "asc"
      ? ArrowUp
      : ArrowDown;
  return (
    <button
      onClick={() => onSort(sortKey)}
      className={`inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
        isActive ? "text-emerald-400" : "text-zinc-600 hover:text-zinc-400"
      }`}
    >
      {label}
      <Icon className="w-3 h-3" />
    </button>
  );
}

export function PlainHeader({ label }: { label: string }): React.JSX.Element {
  return (
    <span className="text-[10px] font-semibold text-zinc-600 uppercase tracking-wider">
      {label}
    </span>
  );
}
